// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s8OQ","left":"styles_left__21blJ","desktopActions":"styles_desktopActions__YZU6I","title":"styles_title__20pAZ"};